// leaveRequestSelectors.ts
import { RootState } from '@/app/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectLeaveRequestState = (state: RootState) => state.leaveRequests;

export const selectUserLeaveRequests = createSelector(
  selectLeaveRequestState,
  (state) => ({
    requests: state.userRequests,
    pagination: state.userPagination,
  })
);

export const selectAdminLeaveRequests = createSelector(
  selectLeaveRequestState,
  (state) => ({
    requests: state.adminRequests,
    pagination: state.adminPagination,
  })
);

export const selectUserRequestsFilters = createSelector(
  selectLeaveRequestState,
  (state) => ({
    type: state.userRequestsFilters.type,
    status: state.userRequestsFilters.status,
  })
);

export const selectAdminLeaveFilters = createSelector(
  selectLeaveRequestState,
  (state) => ({
    type: state.adminRequestsFilters.type,
    status: state.adminRequestsFilters.status,
    search: state.adminRequestsFilters.search,
  })
);

export const selectLeaveRequestError = createSelector(
  selectLeaveRequestState,
  (state) => state.error
);

export const selectUserLeaveCounts = createSelector(
  selectLeaveRequestState,
  (state) => state.userCounts
);

export const selectAdminLoading = createSelector(
  selectLeaveRequestState,
  (state) => state.adminRequestsLoading
);

export const selectUserLoading = createSelector(
  selectLeaveRequestState,
  (state) => state.userRequestsLoading
);
